import { Link } from 'react-router-dom';
import { IMediaAndContent } from '../../interfaces/MediaAndContent';
import MediaAndContentMini from '../Cards/MediaAndContentMini';
import MediaAndContentWithDownload from '../Cards/MediaAndContentWithDownload';

interface IMediaAndContentMapper {
    data: IMediaAndContent[] | null;
}

const ActivitiesMapper = ({ data }: IMediaAndContentMapper) => {
    if (!data || data.length === 0) return null;

    return (
        <div className="my-12 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-x-6  gap-y-10 justify-items-center xl:justify-items-start">
            {data.map((renderContent) => {
                const renderContentKey = renderContent.titulo.replaceAll(" ", '-').replaceAll(':', '').toLowerCase();
                const renderContentLink = `/monitor/actividades/${encodeURIComponent(renderContentKey)}-id${renderContent.id}`;

                return (
                    <Link
                        to={renderContentLink}
                        state={{ id: `${Number(renderContent.id)}` }}
                        key={renderContent.id}
                        className='w-full h-full'
                    >
                        <MediaAndContentMini
                            id={renderContent.id}
                            imagen={renderContent.imagen}
                            titulo={renderContent.titulo}
                            descripcion={renderContent.descripcion}
                            fecha={renderContent.fecha}
                            categorias={renderContent.categorias}
                            variant='brand'
                            fluid={true}
                        />
                    </Link>
                );
            })}
        </div>
    );
};

export default ActivitiesMapper;